import tlds from 'tlds';
import * as yup from 'yup';

yup.addMethod<yup.StringSchema>(yup.string, 'validEmailTld', function (message: string) {
  return this.test({
    name: 'valid-email-tld',
    message,
    test(value) {
      if (!value) return true;
      const [currentTld] = value.split('.').slice(-1);
      return tlds.includes(currentTld.toLowerCase());
    },
  });
});

yup.addMethod<yup.StringSchema>(yup.string, 'validEmailOrMatrixId', function (message: string) {
  return this.test({
    name: 'valid-email-or-matrix-id',
    message,
    test(value) {
      if (!value) return true;

      const matrixIdRegex = /^@[a-zA-Z0-9._=-]+:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (matrixIdRegex.test(value.trim())) {
        return true;
      }

      const [currentTld] = value.split('.').slice(-1);
      return tlds.includes(currentTld.toLowerCase());
    },
  });
});

yup.addMethod<yup.StringSchema>(
  yup.string,
  'emailIsNotDuplicateInArray',
  function (message: string, listField: string) {
    return this.test({
      name: 'email-is-not-duplicate-in-array',
      message,
      test(value, ctx) {
        if (!value) return true;
        const participants: string[] = ctx.resolve(yup.ref(listField)) || [];
        return !participants.includes(value.toLowerCase());
      },
    });
  }
);

yup.addMethod<yup.StringSchema>(
  yup.string,
  'uniqueRoleName',
  function (message: string, existingRoles: { name: string }[], reservedNames: string[]) {
    return this.test({
      name: 'unique-role-name',
      message,
      test(value) {
        if (!value) return true;
        const trimmedValue = value.trim().toLowerCase();
        const isReserved = reservedNames.some((reservedName) => reservedName.toLowerCase() === trimmedValue);
        if (isReserved) return true;

        return !existingRoles.some(({ name }) => name.trim().toLowerCase() === trimmedValue);
      },
    });
  }
);

yup.addMethod<yup.StringSchema>(
  yup.string,
  'reservedRoleName',
  function (message: string, existingDefaultRoleTypes: string[], reservedNames: string[]) {
    return this.test({
      name: 'reserved-role-name',
      message,
      test(value) {
        if (!value || !existingDefaultRoleTypes.length) return true;
        const trimmedValue = value.trim().toLowerCase();
        return !reservedNames.some((reservedName) => reservedName.toLowerCase() === trimmedValue);
      },
    });
  }
);

declare module 'yup' {
  interface StringSchema {
    emailIsNotDuplicateInArray(message: string, listField: string): StringSchema;
    validEmailTld(message: string): StringSchema;
    validEmailOrMatrixId(message: string): StringSchema;
    uniqueRoleName(message: string, existingRoles: { name: string }[], reservedNames: string[]): StringSchema;
    reservedRoleName(message: string, existingDefaultRoleTypes: string[], reservedNames: string[]): StringSchema;
  }
}
